import type { FeatureFlags } from '../api';

export const featureFlags: FeatureFlags = {
  scoringRules: {
    type: 'EXCLUDE',
    rules: [
      '514f0b1c-e272-4d8e-a531-5c45af5872fd',
      '9926c9eb-a1da-48dc-81b8-ec7ad1a7930b',
      'd77ad444-6551-4d96-a1c1-90e852313211',
      'c862029e-d126-4991-a00d-4231b55bd0fd',
      '66e66b7e-dc9c-426c-94bf-6f14918f21c2',
      '55e03f7f-ea1f-40f2-81a7-ea69426e7646',
      'c6d56aa4-f8ff-4482-b44c-8ab69590b8a7',
      'c37c7526-1649-4de9-935b-21e0794671c5',
      '53121fb4-0eb9-4bb9-be20-bece222aeecc',
      '4900e2b5-f199-4051-bf79-731304c4abf4',
      '07a50d02-03d7-4911-bc2c-2bc89527132e',
      'c63b946f-e6ce-4148-b270-ee2ccadbcb38',
      'a98d82fd-afc4-44fe-9935-2342af8e2bc2',
      'cf46a816-f16b-4dab-97ef-73e87ba32deb',
      '8d483d8c-4230-46ea-acb8-f9747b353fe3',
      '37ee77eb-1ab2-4c7c-95f0-1d628b9bd32d',
      '4090289e-a969-46de-99be-12fc860d6f60',
      '14af6f39-c132-4132-a342-069855624010',
      '57995034-02ae-433e-a130-2aa54169bbea',
      '98caf6f7-26da-41ee-a87a-e4b31e7e7de4',
      'd7f3610a-f843-4513-b2b3-d00e3ef7401c',
      'bf0e37f0-c545-4ac1-acca-1d5d0cd13d38',
      '1f171eae-ab69-427d-bdef-0772315ca248',
      'e502208a-56d4-48ac-809d-38be12a59dc7',
      '522167e3-fbd0-4de6-a2e3-d375ff34ec0e',
      '3babdebb-cbad-4c96-9d62-bb86c4d1c603',
      '8fb1b873-cac5-483f-a662-f811f7506eec',
      'bb4061ee-8925-42ba-b623-7e033a814265',
      '70737a30-f4bb-479b-be91-8f0ef2ad663a',
      '30202c88-d888-468c-9439-01fa7d90a2cb',
      'cff6c03f-86e8-4d9a-8a63-5c5f3365321a',
      'e6158ace-c83c-4c0e-bc43-4575699380b5',
      'abc6e4e1-7bdd-41c0-86a5-1b9065fc9672',
      '2baae08b-5260-408d-9cf6-d45efcf6d617',
      'fa0e9eab-8344-490e-b4ae-90aa120db1d3',
      '94dfaf01-ba41-44c9-aa14-adaa00b8a2a7',
      'b1f54852-b407-4a19-b14d-9adfaef180cb',
    ],
  },
  skipProcessActivities: {
    InvokeDuplicatesScoringStage: {
      scoringResult: 'passed',
    },
    InvokeDuplicatesScoringStage2: {
      scoringResult: 'passed',
    },
    InvokeFreeScoringStrategy: {
      scoringResult: 'passed',
      authSelfieFaceId: '01GPWJGPETYJ0B0037DDSD1NK7',
    },
    InvokeFreeScoringStage2: {
      scoringResult: 'passed',
    },
    InvokePostCreateStrategy: {
      scoringResult: 'passed',
    },
    InvokeSdkScoringStrategy: {
      scoringResult: 'passed',
    },
  },
  scoringAbTests: [],
};
